/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../Fixes';
import Builder from '../../../Builder';
import '../../common/time';
import '../../common/currency';
import '../../common/colors';
import '../id_pair';
import '../../common/location';
import '../instruments/service';
import '../creator_details';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "client": {
        "nested": {
          "rolodex": {
            "nested": {
              "BuyerSummary": {
                "fields": {
                  "transactionCount": {
                    "type": "int64",
                    "id": 1,
                    "rule": "optional"
                  },
                  "firstVisit": {
                    "type": "squareup.common.time.DateTime",
                    "id": 2,
                    "rule": "optional"
                  },
                  "lastVisit": {
                    "type": "squareup.common.time.DateTime",
                    "id": 3,
                    "rule": "optional"
                  },
                  "averageTransactionFrequencyMillis": {
                    "type": "int64",
                    "id": 4,
                    "rule": "optional"
                  },
                  "totalSpent": {
                    "type": "squareup.common.Money",
                    "id": 5,
                    "rule": "optional"
                  },
                  "transactionFrequencyDescription": {
                    "type": "string",
                    "id": 6,
                    "rule": "optional"
                  }
                }
              },
              "Contact": {
                "fields": {
                  "contactToken": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "displayName": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "profile": {
                    "type": "squareup.client.rolodex.CustomerProfile",
                    "id": 3,
                    "rule": "optional"
                  },
                  "group": {
                    "type": "squareup.client.rolodex.Group",
                    "id": 4,
                    "rule": "repeated"
                  },
                  "buyerSummary": {
                    "type": "squareup.client.rolodex.BuyerSummary",
                    "id": 5,
                    "rule": "optional"
                  },
                  "instrumentsOnFile": {
                    "type": "squareup.client.rolodex.InstrumentsOnFile",
                    "id": 6,
                    "rule": "optional"
                  },
                  "emailToken": {
                    "type": "string",
                    "id": 7,
                    "rule": "optional"
                  },
                  "phoneToken": {
                    "type": "string",
                    "id": 8,
                    "rule": "optional"
                  },
                  "createdAtMs": {
                    "type": "int64",
                    "id": 9,
                    "rule": "optional"
                  },
                  "note": {
                    "type": "squareup.client.rolodex.Note",
                    "id": 10,
                    "rule": "repeated"
                  },
                  "attributes": {
                    "type": "squareup.client.rolodex.AttributeSchema.Attribute",
                    "id": 11,
                    "rule": "repeated"
                  },
                  "schemaVersion": {
                    "type": "string",
                    "id": 12,
                    "rule": "optional"
                  },
                  "emailSubscriptions": {
                    "type": "squareup.client.rolodex.EmailSubscriptions",
                    "id": 13,
                    "rule": "optional"
                  },
                  "attachments": {
                    "type": "squareup.client.rolodex.Attachment",
                    "id": 14,
                    "rule": "repeated"
                  },
                  "creationSource": {
                    "type": "string",
                    "id": 15,
                    "rule": "optional"
                  },
                  "appFields": {
                    "type": "squareup.client.rolodex.AppField",
                    "id": 16,
                    "rule": "repeated"
                  },
                  "frequentItems": {
                    "type": "squareup.client.rolodex.FrequentItem",
                    "id": 17,
                    "rule": "repeated"
                  },
                  "merchantProvidedId": {
                    "type": "string",
                    "id": 18,
                    "rule": "optional"
                  },
                  "applicationFields": {
                    "type": "squareup.client.rolodex.ApplicationFields",
                    "id": 19,
                    "rule": "optional"
                  },
                  "recentTransactions": {
                    "type": "squareup.client.rolodex.Transaction",
                    "id": 20,
                    "rule": "repeated"
                  },
                  "emailMarketingSubscribed": {
                    "type": "bool",
                    "id": 21,
                    "rule": "optional"
                  }
                }
              },
              "ApplicationFields": {
                "fields": {
                  "appointmentsEmailNotificationSetting": {
                    "type": "bool",
                    "id": 1,
                    "rule": "optional"
                  },
                  "appointmentsPhoneNotificationSetting": {
                    "type": "bool",
                    "id": 2,
                    "rule": "optional"
                  }
                }
              },
              "EmailSubscriptions": {
                "fields": {
                  "canReceiveDirectMessaging": {
                    "type": "bool",
                    "id": 1,
                    "rule": "optional"
                  }
                }
              },
              "FrequentItem": {
                "fields": {
                  "displayName": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "purchaseCount": {
                    "type": "double",
                    "id": 3,
                    "rule": "optional"
                  },
                  "imageUrl": {
                    "type": "string",
                    "id": 4,
                    "rule": "optional"
                  },
                  "color": {
                    "type": "squareup.common.RGBAColor",
                    "id": 5,
                    "rule": "optional"
                  },
                  "categoryName": {
                    "type": "string",
                    "id": 6,
                    "rule": "optional"
                  },
                  "transactionCount": {
                    "type": "int32",
                    "id": 7,
                    "rule": "optional"
                  },
                  "abbreviation": {
                    "type": "string",
                    "id": 8,
                    "rule": "optional"
                  }
                }
              },
              "Transaction": {
                "fields": {
                  "paymentToken": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "unitToken": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "locationName": {
                    "type": "string",
                    "id": 3,
                    "rule": "optional"
                  },
                  "completedAt": {
                    "type": "squareup.common.time.DateTime",
                    "id": 4,
                    "rule": "optional"
                  },
                  "itemization": {
                    "type": "squareup.client.rolodex.Itemization",
                    "id": 5,
                    "rule": "repeated"
                  },
                  "billToken": {
                    "type": "string",
                    "id": 6,
                    "rule": "optional"
                  }
                }
              },
              "Itemization": {
                "fields": {
                  "itemId": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "itemName": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "itemVariationId": {
                    "type": "string",
                    "id": 3,
                    "rule": "optional"
                  },
                  "itemVariationName": {
                    "type": "string",
                    "id": 4,
                    "rule": "optional"
                  },
                  "imageUrl": {
                    "type": "string",
                    "id": 5,
                    "rule": "optional"
                  },
                  "quantity": {
                    "type": "double",
                    "id": 6,
                    "rule": "optional"
                  },
                  "itemModifier": {
                    "type": "squareup.client.rolodex.ItemModifier",
                    "id": 7,
                    "rule": "repeated"
                  },
                  "iconColor": {
                    "type": "squareup.common.RGBAColor",
                    "id": 8,
                    "rule": "optional"
                  },
                  "abbreviation": {
                    "type": "string",
                    "id": 9,
                    "rule": "optional"
                  },
                  "translationType": {
                    "type": "string",
                    "id": 10,
                    "rule": "optional"
                  }
                }
              },
              "ItemModifier": {
                "fields": {
                  "adjustmentGroup": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "name": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "itemModifierList": {
                    "type": "squareup.client.rolodex.ItemModifierList",
                    "id": 3,
                    "rule": "optional"
                  }
                }
              },
              "ItemModifierList": {
                "fields": {
                  "id": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "name": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "selectionType": {
                    "type": "squareup.client.rolodex.ItemModifierList.SelectionType",
                    "id": 3,
                    "rule": "optional"
                  }
                },
                "nested": {
                  "SelectionType": {
                    "values": {
                      "SINGLE": 0,
                      "MULTIPLE": 1
                    }
                  }
                }
              },
              "GroupType": {
                "values": {
                  "MANUAL_GROUP": 1,
                  "AUDIENCE_GROUP": 2
                }
              },
              "AudienceType": {
                "values": {
                  "NONE": 0,
                  "CHURN_RISK": 1,
                  "LOYAL": 2,
                  "REACHABLE": 3,
                  "CARDS_ON_FILE": 4,
                  "GROUP_V2_SMART": 5
                }
              },
              "Group": {
                "fields": {
                  "groupToken": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "merchantToken": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "displayName": {
                    "type": "string",
                    "id": 3,
                    "rule": "optional"
                  },
                  "groupType": {
                    "type": "squareup.client.rolodex.GroupType",
                    "id": 4,
                    "rule": "optional"
                  },
                  "audienceType": {
                    "type": "squareup.client.rolodex.AudienceType",
                    "id": 5,
                    "rule": "optional"
                  },
                  "numManualContacts": {
                    "type": "int64",
                    "id": 6,
                    "rule": "optional"
                  },
                  "numCustomers": {
                    "type": "int64",
                    "id": 7,
                    "rule": "optional"
                  },
                  "filters": {
                    "type": "squareup.client.rolodex.Filter",
                    "id": 8,
                    "rule": "repeated"
                  },
                  "hasAdvancedFilters": {
                    "type": "bool",
                    "id": 9,
                    "rule": "optional"
                  }
                }
              },
              "Segment": {
                "fields": {
                  "segmentTokenPair": {
                    "type": "squareup.client.IdPair",
                    "id": 1,
                    "rule": "required"
                  },
                  "merchantToken": {
                    "type": "string",
                    "id": 2,
                    "rule": "required"
                  },
                  "name": {
                    "type": "string",
                    "id": 3,
                    "rule": "optional"
                  },
                  "filters": {
                    "type": "squareup.client.rolodex.Filter",
                    "id": 4,
                    "rule": "repeated"
                  },
                  "numCustomers": {
                    "type": "int64",
                    "id": 5,
                    "rule": "optional"
                  },
                  "numEmailable": {
                    "type": "int64",
                    "id": 6,
                    "rule": "optional"
                  },
                  "hidden": {
                    "type": "bool",
                    "id": 7,
                    "rule": "optional"
                  },
                  "hasAdvancedFilters": {
                    "type": "bool",
                    "id": 8,
                    "rule": "optional"
                  },
                  "v1Type": {
                    "type": "squareup.client.rolodex.AudienceType",
                    "id": 9,
                    "rule": "optional"
                  }
                }
              },
              "GroupV2": {
                "fields": {
                  "type": {
                    "type": "squareup.client.rolodex.GroupV2.Type",
                    "id": 1,
                    "rule": "optional"
                  },
                  "groupIdPair": {
                    "type": "squareup.client.IdPair",
                    "id": 2,
                    "rule": "optional"
                  },
                  "merchantToken": {
                    "type": "string",
                    "id": 3,
                    "rule": "optional"
                  },
                  "name": {
                    "type": "string",
                    "id": 4,
                    "rule": "optional"
                  },
                  "filters": {
                    "type": "squareup.client.rolodex.Filter",
                    "id": 5,
                    "rule": "repeated"
                  },
                  "counts": {
                    "type": "squareup.client.rolodex.GroupV2Counts",
                    "id": 6,
                    "rule": "optional"
                  },
                  "hasAdvancedFilters": {
                    "type": "bool",
                    "id": 7,
                    "rule": "optional"
                  }
                },
                "nested": {
                  "Type": {
                    "values": {
                      "INVALID": 0,
                      "MANUAL": 1,
                      "SMART": 2
                    }
                  }
                }
              },
              "GroupV2Options": {
                "fields": {
                  "includeCounts": {
                    "type": "bool",
                    "id": 1,
                    "rule": "optional"
                  }
                }
              },
              "GroupV2Counts": {
                "fields": {
                  "numCustomers": {
                    "type": "int32",
                    "id": 1,
                    "rule": "optional"
                  },
                  "numEmailable": {
                    "type": "int32",
                    "id": 2,
                    "rule": "optional"
                  },
                  "numManual": {
                    "type": "int32",
                    "id": 3,
                    "rule": "optional"
                  }
                }
              },
              "CustomerProfile": {
                "fields": {
                  "version": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "merchantProvidedId": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "givenName": {
                    "type": "string",
                    "id": 3,
                    "rule": "optional"
                  },
                  "surname": {
                    "type": "string",
                    "id": 4,
                    "rule": "optional"
                  },
                  "nickname": {
                    "type": "string",
                    "id": 5,
                    "rule": "optional"
                  },
                  "companyName": {
                    "type": "string",
                    "id": 6,
                    "rule": "optional"
                  },
                  "birthday": {
                    "type": "squareup.common.time.YearMonthDay",
                    "id": 7,
                    "rule": "optional"
                  },
                  "memo": {
                    "type": "string",
                    "id": 8,
                    "rule": "optional"
                  },
                  "emailAddress": {
                    "type": "string",
                    "id": 9,
                    "rule": "optional"
                  },
                  "phoneNumber": {
                    "type": "string",
                    "id": 10,
                    "rule": "optional"
                  },
                  "address": {
                    "type": "squareup.common.location.GlobalAddress",
                    "id": 11,
                    "rule": "optional"
                  },
                  "maskedEmailAddress": {
                    "type": "string",
                    "id": 12,
                    "rule": "optional"
                  },
                  "maskedPhoneNumber": {
                    "type": "string",
                    "id": 13,
                    "rule": "optional"
                  },
                  "maskedAddress": {
                    "type": "string",
                    "id": 14,
                    "rule": "optional"
                  },
                  "taxId": {
                    "type": "string",
                    "id": 15,
                    "rule": "optional"
                  },
                  "phoneticGivenName": {
                    "type": "string",
                    "id": 16,
                    "rule": "optional"
                  },
                  "phoneticSurname": {
                    "type": "string",
                    "id": 17,
                    "rule": "optional"
                  },
                  "timeZone": {
                    "type": "string",
                    "id": 18,
                    "rule": "optional"
                  }
                }
              },
              "InstrumentsOnFile": {
                "fields": {
                  "instrument": {
                    "type": "squareup.client.instruments.InstrumentSummary",
                    "id": 1,
                    "rule": "repeated"
                  }
                }
              },
              "EventType": {
                "values": {
                  "SKIPPED": 0,
                  "MARKETING_EMAIL": 1,
                  "PAYMENT": 2,
                  "FEEDBACK_CONVERSATION": 3,
                  "LOYALTY_ADJUSTMENT": 4,
                  "LOYALTY_REWARD": 5,
                  "STATUS_TIER_POINTS_ACCRUAL": 6,
                  "STATUS_TIER_UPGRADE": 7,
                  "STATUS_TIER_DOWNGRADE": 8,
                  "LOYALTY_EMAIL_IMPORT": 9,
                  "MARKETING_EMAIL_EXPIRATION_REMINDER": 10,
                  "CARD_ON_FILE_LINK": 11,
                  "CARD_ON_FILE_UNLINK": 12,
                  "NOTE": 13,
                  "MARKETING_EMAIL_SUBSCRIPTION": 14,
                  "COUPON_ISSUE": 15,
                  "COUPON_REDEMPTION": 16,
                  "LOYALTY_ENROLLMENT": 17,
                  "LOYALTY_STAR_ACCURAL": 18,
                  "LOYALTY_MANUAL_INCREMENT": 19,
                  "LOYALTY_MANUAL_DECREMENT": 20,
                  "LOYALTY_STAR_TRANSFER": 21,
                  "LOYALTY_MAILING_LIST_SIGNUP": 22,
                  "LOYALTY_ACCOUNT_STATUS_SMS": 23,
                  "LOYALTY_STAR_IMPORT": 24,
                  "LOYALTY_API_ENROLLMENT": 25,
                  "EMAIL_COLLECTION": 26,
                  "LOYALTY_OFF_POS_ENROLLMENT": 27,
                  "LOYALTY_OFF_POS_STAR_ACCURAL": 28,
                  "LOYALTY_REWARD_REDEMPTION": 29,
                  "LOYALTY_POINTS_REDEMPTION": 30,
                  "LOYALTY_REWARD_ISSUED": 31,
                  "LOYALTY_POINTS_EXPIRATION": 32,
                  "LOYALTY_BUYER_LOGIN_ENROLLMENT": 33,
                  "LOYALTY_REFUND": 34,
                  "LOYALTY_POSITIVE_EXCHANGE": 35,
                  "LOYALTY_NEGATIVE_EXCHANGE": 36,
                  "LOYALTY_API_POINTS_ACCURAL": 37,
                  "LOYALTY_API_POINTS_AUTO_ACCURAL": 38,
                  "LOYALTY_APPLE_VAS_ENROLLMENT": 39,
                  "LOYALTY_PROMOTION_POINTS_ACCURAL": 40
                }
              },
              "Event": {
                "fields": {
                  "eventToken": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "title": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "subtitle": {
                    "type": "string",
                    "id": 3,
                    "rule": "optional"
                  },
                  "linkRelativeUrl": {
                    "type": "string",
                    "id": 4,
                    "rule": "optional"
                  },
                  "occurredAt": {
                    "type": "squareup.common.time.DateTime",
                    "id": 5,
                    "rule": "optional"
                  },
                  "type": {
                    "type": "squareup.client.rolodex.EventType",
                    "id": 6,
                    "rule": "optional"
                  },
                  "unitToken": {
                    "type": "string",
                    "id": 8,
                    "rule": "optional"
                  }
                }
              },
              "Reminder": {
                "fields": {
                  "scheduledAt": {
                    "type": "squareup.common.time.DateTime",
                    "id": 1,
                    "rule": "optional"
                  }
                }
              },
              "Note": {
                "fields": {
                  "noteToken": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "occurredAt": {
                    "type": "squareup.common.time.DateTime",
                    "id": 2,
                    "rule": "optional"
                  },
                  "body": {
                    "type": "string",
                    "id": 3,
                    "rule": "optional"
                  },
                  "creatorDetails": {
                    "type": "squareup.client.CreatorDetails",
                    "id": 4,
                    "rule": "optional"
                  },
                  "contactToken": {
                    "type": "string",
                    "id": 5,
                    "rule": "optional"
                  },
                  "reminder": {
                    "type": "squareup.client.rolodex.Reminder",
                    "id": 6,
                    "rule": "optional"
                  }
                }
              },
              "Merchant": {
                "fields": {
                  "manualCustomerCount": {
                    "type": "int32",
                    "id": 1,
                    "rule": "optional"
                  },
                  "unreadMessagesCount": {
                    "type": "int32",
                    "id": 2,
                    "rule": "optional"
                  },
                  "attributeSchema": {
                    "type": "squareup.client.rolodex.AttributeSchema",
                    "id": 3,
                    "rule": "optional"
                  },
                  "numCustomers": {
                    "type": "int32",
                    "id": 4,
                    "rule": "optional"
                  },
                  "merchantSettings": {
                    "type": "squareup.client.rolodex.MerchantSettings",
                    "id": 5,
                    "rule": "optional"
                  }
                }
              },
              "MerchantSettings": {
                "fields": {
                  "enableAutomaticContactCreation": {
                    "type": "bool",
                    "id": 1,
                    "rule": "optional"
                  },
                  "supportPhoneticNames": {
                    "type": "bool",
                    "id": 2,
                    "rule": "optional"
                  },
                  "hasSeenInstantProfilesIntroduction": {
                    "type": "bool",
                    "id": 3,
                    "rule": "optional"
                  },
                  "supportEmailMarketingOptIn": {
                    "type": "bool",
                    "id": 4,
                    "rule": "optional"
                  }
                }
              },
              "AttributeSchema": {
                "fields": {
                  "version": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "attributeDefinitions": {
                    "type": "squareup.client.rolodex.AttributeSchema.AttributeDefinition",
                    "id": 2,
                    "rule": "repeated"
                  },
                  "attributeKeysInOrder": {
                    "type": "string",
                    "id": 3,
                    "rule": "repeated"
                  }
                },
                "nested": {
                  "Type": {
                    "values": {
                      "UNKNOWN": 0,
                      "NUMBER": 1,
                      "BOOLEAN": 2,
                      "TEXT": 3,
                      "ENUM": 4,
                      "PHONE": 5,
                      "EMAIL": 6,
                      "ADDRESS": 7,
                      "DATE": 8
                    }
                  },
                  "Visibility": {
                    "values": {
                      "VISIBILITY_UNKNOWN": 0,
                      "VISIBILITY_HIDDEN": 1,
                      "VISIBILITY_READ": 2,
                      "VISIBILITY_READ_WRITE": 3
                    }
                  },
                  "AttributeDefinition": {
                    "fields": {
                      "key": {
                        "type": "string",
                        "id": 1,
                        "rule": "optional"
                      },
                      "name": {
                        "type": "string",
                        "id": 2,
                        "rule": "optional"
                      },
                      "type": {
                        "type": "squareup.client.rolodex.AttributeSchema.Type",
                        "id": 3,
                        "rule": "optional"
                      },
                      "isVisibleInProfile": {
                        "type": "bool",
                        "id": 4,
                        "rule": "optional"
                      },
                      "isReadOnly": {
                        "type": "bool",
                        "id": 5,
                        "rule": "optional"
                      },
                      "enumAllowMultiple": {
                        "type": "bool",
                        "id": 6,
                        "rule": "optional"
                      },
                      "enumValues": {
                        "type": "string",
                        "id": 7,
                        "rule": "repeated"
                      },
                      "isDefault": {
                        "type": "bool",
                        "id": 8,
                        "rule": "optional"
                      },
                      "isConfigurable": {
                        "type": "bool",
                        "id": 9,
                        "rule": "optional"
                      },
                      "visibility": {
                        "type": "squareup.client.rolodex.AttributeSchema.Visibility",
                        "id": 10,
                        "rule": "optional"
                      },
                      "owner": {
                        "type": "string",
                        "id": 11,
                        "rule": "optional"
                      }
                    }
                  },
                  "Attribute": {
                    "fields": {
                      "key": {
                        "type": "string",
                        "id": 1,
                        "rule": "optional"
                      },
                      "name": {
                        "type": "string",
                        "id": 2,
                        "rule": "optional"
                      },
                      "type": {
                        "type": "squareup.client.rolodex.AttributeSchema.Type",
                        "id": 3,
                        "rule": "optional"
                      },
                      "fallbackValue": {
                        "type": "string",
                        "id": 4,
                        "rule": "optional"
                      },
                      "data": {
                        "type": "squareup.client.rolodex.AttributeSchema.Attribute.Data",
                        "id": 5,
                        "rule": "optional"
                      },
                      "isVisibleInProfile": {
                        "type": "bool",
                        "id": 6,
                        "rule": "optional"
                      },
                      "wasBooleanEverSet": {
                        "type": "bool",
                        "id": 7,
                        "rule": "optional"
                      },
                      "visibility": {
                        "type": "squareup.client.rolodex.AttributeSchema.Visibility",
                        "id": 8,
                        "rule": "optional"
                      },
                      "owner": {
                        "type": "string",
                        "id": 9,
                        "rule": "optional"
                      }
                    },
                    "nested": {
                      "Data": {
                        "fields": {
                          "number": {
                            "type": "float",
                            "id": 1,
                            "rule": "optional"
                          },
                          "boolean": {
                            "type": "bool",
                            "id": 2,
                            "rule": "optional"
                          },
                          "text": {
                            "type": "string",
                            "id": 3,
                            "rule": "optional"
                          },
                          "numberText": {
                            "type": "string",
                            "id": 4,
                            "rule": "optional"
                          },
                          "enumValues": {
                            "type": "string",
                            "id": 5,
                            "rule": "repeated"
                          },
                          "phone": {
                            "type": "string",
                            "id": 6,
                            "rule": "optional"
                          },
                          "email": {
                            "type": "string",
                            "id": 7,
                            "rule": "optional"
                          },
                          "address": {
                            "type": "squareup.common.location.GlobalAddress",
                            "id": 8,
                            "rule": "optional"
                          },
                          "date": {
                            "type": "squareup.common.time.DateTime",
                            "id": 9,
                            "rule": "optional"
                          }
                        }
                      }
                    }
                  }
                }
              },
              "MergeProposal": {
                "fields": {
                  "duplicateContacts": {
                    "type": "squareup.client.rolodex.Contact",
                    "id": 1,
                    "rule": "repeated"
                  },
                  "newContact": {
                    "type": "squareup.client.rolodex.Contact",
                    "id": 2,
                    "rule": "optional"
                  }
                }
              },
              "DuplicateContactTokenSet": {
                "fields": {
                  "duplicateContactTokens": {
                    "type": "string",
                    "id": 1,
                    "rule": "repeated"
                  }
                }
              },
              "ContactSet": {
                "fields": {
                  "type": {
                    "type": "squareup.client.rolodex.ContactSetType",
                    "id": 1,
                    "rule": "optional"
                  },
                  "contactTokensIncluded": {
                    "type": "string",
                    "id": 2,
                    "rule": "repeated"
                  },
                  "groupToken": {
                    "type": "string",
                    "id": 3,
                    "rule": "optional"
                  },
                  "contactTokensExcluded": {
                    "type": "string",
                    "id": 4,
                    "rule": "repeated"
                  },
                  "contactCount": {
                    "type": "int32",
                    "id": 5,
                    "rule": "optional"
                  }
                }
              },
              "ContactSetType": {
                "values": {
                  "ALL_CONTACTS": 1,
                  "INCLUDED_CONTACTS": 2,
                  "GROUP": 3
                }
              },
              "ContactBatchActionStatus": {
                "fields": {
                  "totalSuccessCount": {
                    "type": "int32",
                    "id": 1,
                    "rule": "optional"
                  },
                  "totalErrorCount": {
                    "type": "int32",
                    "id": 2,
                    "rule": "optional"
                  }
                }
              },
              "Filter": {
                "fields": {
                  "type": {
                    "type": "squareup.client.rolodex.Filter.Type",
                    "id": 1,
                    "rule": "optional"
                  },
                  "displayName": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "allowMultiplesInConjunction": {
                    "type": "bool",
                    "id": 3,
                    "rule": "optional"
                  },
                  "groupToken": {
                    "type": "string",
                    "id": 100,
                    "rule": "optional"
                  },
                  "mgGroupTokens": {
                    "type": "string",
                    "id": 101,
                    "rule": "repeated"
                  },
                  "xpilydXPayments": {
                    "type": "int32",
                    "id": 200,
                    "rule": "optional"
                  },
                  "xpilydXPaymentsFieldName": {
                    "type": "string",
                    "id": 201,
                    "rule": "optional"
                  },
                  "xpilydYDays": {
                    "type": "squareup.client.rolodex.Filter.Option",
                    "id": 202,
                    "rule": "optional"
                  },
                  "xpilydYDaysFieldName": {
                    "type": "string",
                    "id": 203,
                    "rule": "optional"
                  },
                  "xpilydYDaysOptions": {
                    "type": "squareup.client.rolodex.Filter.Option",
                    "id": 204,
                    "rule": "repeated"
                  },
                  "lpilydYDays": {
                    "type": "squareup.client.rolodex.Filter.Option",
                    "id": 300,
                    "rule": "optional"
                  },
                  "lpilydYDaysOptions": {
                    "type": "squareup.client.rolodex.Filter.Option",
                    "id": 301,
                    "rule": "repeated"
                  },
                  "npilydYDays": {
                    "type": "squareup.client.rolodex.Filter.Option",
                    "id": 400,
                    "rule": "optional"
                  },
                  "npilydYDaysOptions": {
                    "type": "squareup.client.rolodex.Filter.Option",
                    "id": 401,
                    "rule": "repeated"
                  },
                  "rXPayments": {
                    "type": "int32",
                    "id": 500,
                    "rule": "optional"
                  },
                  "rXPaymentsFieldName": {
                    "type": "string",
                    "id": 501,
                    "rule": "optional"
                  },
                  "rYDays": {
                    "type": "squareup.client.rolodex.Filter.Option",
                    "id": 502,
                    "rule": "optional"
                  },
                  "rYDaysFieldName": {
                    "type": "string",
                    "id": 503,
                    "rule": "optional"
                  },
                  "rYDaysOptions": {
                    "type": "squareup.client.rolodex.Filter.Option",
                    "id": 504,
                    "rule": "repeated"
                  },
                  "catAttributeToken": {
                    "type": "string",
                    "id": 600,
                    "rule": "optional"
                  },
                  "catAttributeValue": {
                    "type": "string",
                    "id": 601,
                    "rule": "optional"
                  },
                  "catCondition": {
                    "type": "squareup.client.rolodex.CustomAttributeText.Condition",
                    "id": 602,
                    "rule": "optional"
                  },
                  "caeAttributeToken": {
                    "type": "string",
                    "id": 700,
                    "rule": "optional"
                  },
                  "caeAttributeValue": {
                    "type": "string",
                    "id": 701,
                    "rule": "optional"
                  },
                  "capAttributeToken": {
                    "type": "string",
                    "id": 800,
                    "rule": "optional"
                  },
                  "capAttributeValue": {
                    "type": "string",
                    "id": 801,
                    "rule": "optional"
                  },
                  "caenAttributeToken": {
                    "type": "string",
                    "id": 900,
                    "rule": "optional"
                  },
                  "caenAttributeValues": {
                    "type": "squareup.client.rolodex.Filter.Option",
                    "id": 901,
                    "rule": "repeated"
                  },
                  "caenAttributeOptions": {
                    "type": "squareup.client.rolodex.Filter.Option",
                    "id": 902,
                    "rule": "repeated"
                  },
                  "cabAttributeToken": {
                    "type": "string",
                    "id": 1000,
                    "rule": "optional"
                  },
                  "cabAttributeValue": {
                    "type": "squareup.client.rolodex.Filter.Option",
                    "id": 1001,
                    "rule": "optional"
                  },
                  "cabAttributeOptions": {
                    "type": "squareup.client.rolodex.Filter.Option",
                    "id": 1002,
                    "rule": "repeated"
                  },
                  "fbSentimentType": {
                    "type": "squareup.client.rolodex.Filter.Option",
                    "id": 1100,
                    "rule": "optional"
                  },
                  "fbSentimentTypeOptions": {
                    "type": "squareup.client.rolodex.Filter.Option",
                    "id": 1101,
                    "rule": "repeated"
                  },
                  "sqSearchQuery": {
                    "type": "string",
                    "id": 1200,
                    "rule": "optional"
                  },
                  "sqFullEmailAddress": {
                    "type": "string",
                    "id": 1201,
                    "rule": "optional"
                  },
                  "sqFullPhoneNumber": {
                    "type": "string",
                    "id": 1202,
                    "rule": "optional"
                  },
                  "hcofHasCardOnFile": {
                    "type": "squareup.client.rolodex.Filter.Option",
                    "id": 1300,
                    "rule": "optional"
                  },
                  "hcofHasCardOnFileOptions": {
                    "type": "squareup.client.rolodex.Filter.Option",
                    "id": 1301,
                    "rule": "repeated"
                  },
                  "hlHasLoyalty": {
                    "type": "squareup.client.rolodex.Filter.Option",
                    "id": 1400,
                    "rule": "optional"
                  },
                  "hlHasLoyaltyOptions": {
                    "type": "squareup.client.rolodex.Filter.Option",
                    "id": 1401,
                    "rule": "repeated"
                  },
                  "hvlLocations": {
                    "type": "squareup.client.rolodex.Filter.Option",
                    "id": 1600,
                    "rule": "repeated"
                  },
                  "hvlLocationsOptions": {
                    "type": "squareup.client.rolodex.Filter.Option",
                    "id": 1601,
                    "rule": "repeated"
                  },
                  "csCreationSourceTypes": {
                    "type": "squareup.client.rolodex.Filter.Option",
                    "id": 1700,
                    "rule": "repeated"
                  },
                  "csCreationSourceTypesOptions": {
                    "type": "squareup.client.rolodex.Filter.Option",
                    "id": 1701,
                    "rule": "repeated"
                  },
                  "iipIsInstantProfile": {
                    "type": "squareup.client.rolodex.Filter.Option",
                    "id": 1800,
                    "rule": "optional"
                  },
                  "iipIsInstantProfileOptions": {
                    "type": "squareup.client.rolodex.Filter.Option",
                    "id": 1801,
                    "rule": "repeated"
                  }
                },
                "nested": {
                  "Option": {
                    "fields": {
                      "value": {
                        "type": "string",
                        "id": 1,
                        "rule": "optional"
                      },
                      "label": {
                        "type": "string",
                        "id": 2,
                        "rule": "optional"
                      }
                    }
                  },
                  "Type": {
                    "values": {
                      "UNKNOWN": 0,
                      "MANUAL_GROUP": 1,
                      "X_PAYMENTS_IN_LAST_Y_DAYS": 2,
                      "LAST_PAYMENT_IN_LAST_Y_DAYS": 3,
                      "NO_PAYMENT_IN_LAST_Y_DAYS": 4,
                      "REACHABLE": 5,
                      "CUSTOM_ATTRIBUTE_TEXT": 6,
                      "HAS_CARD_ON_FILE": 7,
                      "CUSTOM_ATTRIBUTE_PHONE": 8,
                      "CUSTOM_ATTRIBUTE_EMAIL": 9,
                      "CUSTOM_ATTRIBUTE_BOOLEAN": 10,
                      "CUSTOM_ATTRIBUTE_ENUM": 11,
                      "FEEDBACK": 12,
                      "SEARCH_QUERY": 13,
                      "HAS_LOYALTY": 14,
                      "HAS_VISITED_LOCATION": 15,
                      "CREATION_SOURCE_FILTER": 16,
                      "IS_INSTANT_PROFILE": 17
                    }
                  }
                }
              },
              "CustomAttributeText": {
                "fields": {},
                "nested": {
                  "Condition": {
                    "values": {
                      "UNKNOWN": 0,
                      "EQUALS": 1
                    }
                  }
                }
              },
              "CustomAttributeEmail": {
                "fields": {}
              },
              "CustomAttributePhone": {
                "fields": {}
              },
              "Attachment": {
                "fields": {
                  "attachmentToken": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "contactToken": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "fileName": {
                    "type": "string",
                    "id": 3,
                    "rule": "optional"
                  },
                  "fileType": {
                    "type": "squareup.client.rolodex.Attachment.FileType",
                    "id": 4,
                    "rule": "optional"
                  },
                  "state": {
                    "type": "squareup.client.rolodex.Attachment.State",
                    "id": 5,
                    "rule": "optional"
                  },
                  "contentType": {
                    "type": "string",
                    "id": 6,
                    "rule": "optional"
                  },
                  "fileSizeInBytes": {
                    "type": "uint64",
                    "id": 7,
                    "rule": "optional"
                  },
                  "fileContent": {
                    "type": "bytes",
                    "id": 8,
                    "rule": "optional"
                  },
                  "createdAt": {
                    "type": "squareup.common.time.DateTime",
                    "id": 9,
                    "rule": "optional"
                  },
                  "updatedAt": {
                    "type": "squareup.common.time.DateTime",
                    "id": 10,
                    "rule": "optional"
                  }
                },
                "nested": {
                  "FileType": {
                    "values": {
                      "UNKNOWN_FILE_TYPE": 0,
                      "IMAGE": 1,
                      "PDF": 2
                    }
                  },
                  "State": {
                    "values": {
                      "PENDING": 1,
                      "ACTIVE": 2,
                      "DELETED": 3
                    }
                  }
                }
              },
              "AppField": {
                "fields": {
                  "appId": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "name": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "type": {
                    "type": "squareup.client.rolodex.AppField.Type",
                    "id": 3,
                    "rule": "optional"
                  },
                  "textValue": {
                    "type": "string",
                    "id": 4,
                    "rule": "optional"
                  },
                  "dateValue": {
                    "type": "squareup.common.time.DateTime",
                    "id": 5,
                    "rule": "optional"
                  },
                  "intValue": {
                    "type": "int64",
                    "id": 6,
                    "rule": "optional"
                  },
                  "datetimeValue": {
                    "type": "squareup.common.time.DateTime",
                    "id": 7,
                    "rule": "optional"
                  }
                },
                "nested": {
                  "Type": {
                    "values": {
                      "UNKNOWN": 0,
                      "TEXT": 1,
                      "EMAIL_ADDRESS": 2,
                      "PHONE_NUMBER": 3,
                      "DATETIME": 4,
                      "INTEGER": 5
                    }
                  }
                }
              },
              "ContactIncludeDataType": {
                "values": {
                  "INSTRUMENTS_ON_FILE": 1
                }
              },
              "ContactIncludeResult": {
                "fields": {
                  "type": {
                    "type": "squareup.client.rolodex.ContactIncludeDataType",
                    "id": 1,
                    "rule": "optional"
                  },
                  "success": {
                    "type": "bool",
                    "id": 2,
                    "rule": "required"
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.client?.nested?.rolodex?.nested?.BuyerSummary && !$root.nested?.squareup?.nested?.client?.nested?.rolodex?.nested?.Contact && !$root.nested?.squareup?.nested?.client?.nested?.rolodex?.nested?.ApplicationFields && !$root.nested?.squareup?.nested?.client?.nested?.rolodex?.nested?.EmailSubscriptions && !$root.nested?.squareup?.nested?.client?.nested?.rolodex?.nested?.FrequentItem && !$root.nested?.squareup?.nested?.client?.nested?.rolodex?.nested?.Transaction && !$root.nested?.squareup?.nested?.client?.nested?.rolodex?.nested?.Itemization && !$root.nested?.squareup?.nested?.client?.nested?.rolodex?.nested?.ItemModifier && !$root.nested?.squareup?.nested?.client?.nested?.rolodex?.nested?.ItemModifierList && !$root.nested?.squareup?.nested?.client?.nested?.rolodex?.nested?.ItemModifierList?.nested?.SelectionType && !$root.nested?.squareup?.nested?.client?.nested?.rolodex?.nested?.GroupType && !$root.nested?.squareup?.nested?.client?.nested?.rolodex?.nested?.AudienceType && !$root.nested?.squareup?.nested?.client?.nested?.rolodex?.nested?.Group && !$root.nested?.squareup?.nested?.client?.nested?.rolodex?.nested?.Segment && !$root.nested?.squareup?.nested?.client?.nested?.rolodex?.nested?.GroupV2 && !$root.nested?.squareup?.nested?.client?.nested?.rolodex?.nested?.GroupV2?.nested?.Type && !$root.nested?.squareup?.nested?.client?.nested?.rolodex?.nested?.GroupV2Options && !$root.nested?.squareup?.nested?.client?.nested?.rolodex?.nested?.GroupV2Counts && !$root.nested?.squareup?.nested?.client?.nested?.rolodex?.nested?.CustomerProfile && !$root.nested?.squareup?.nested?.client?.nested?.rolodex?.nested?.InstrumentsOnFile && !$root.nested?.squareup?.nested?.client?.nested?.rolodex?.nested?.EventType && !$root.nested?.squareup?.nested?.client?.nested?.rolodex?.nested?.Event && !$root.nested?.squareup?.nested?.client?.nested?.rolodex?.nested?.Reminder && !$root.nested?.squareup?.nested?.client?.nested?.rolodex?.nested?.Note && !$root.nested?.squareup?.nested?.client?.nested?.rolodex?.nested?.Merchant && !$root.nested?.squareup?.nested?.client?.nested?.rolodex?.nested?.MerchantSettings && !$root.nested?.squareup?.nested?.client?.nested?.rolodex?.nested?.AttributeSchema && !$root.nested?.squareup?.nested?.client?.nested?.rolodex?.nested?.AttributeSchema?.nested?.Type && !$root.nested?.squareup?.nested?.client?.nested?.rolodex?.nested?.AttributeSchema?.nested?.Visibility && !$root.nested?.squareup?.nested?.client?.nested?.rolodex?.nested?.AttributeSchema?.nested?.AttributeDefinition && !$root.nested?.squareup?.nested?.client?.nested?.rolodex?.nested?.AttributeSchema?.nested?.Attribute && !$root.nested?.squareup?.nested?.client?.nested?.rolodex?.nested?.AttributeSchema?.nested?.Attribute?.nested?.Data && !$root.nested?.squareup?.nested?.client?.nested?.rolodex?.nested?.MergeProposal && !$root.nested?.squareup?.nested?.client?.nested?.rolodex?.nested?.DuplicateContactTokenSet && !$root.nested?.squareup?.nested?.client?.nested?.rolodex?.nested?.ContactSet && !$root.nested?.squareup?.nested?.client?.nested?.rolodex?.nested?.ContactSetType && !$root.nested?.squareup?.nested?.client?.nested?.rolodex?.nested?.ContactBatchActionStatus && !$root.nested?.squareup?.nested?.client?.nested?.rolodex?.nested?.Filter && !$root.nested?.squareup?.nested?.client?.nested?.rolodex?.nested?.Filter?.nested?.Option && !$root.nested?.squareup?.nested?.client?.nested?.rolodex?.nested?.Filter?.nested?.Type && !$root.nested?.squareup?.nested?.client?.nested?.rolodex?.nested?.CustomAttributeText && !$root.nested?.squareup?.nested?.client?.nested?.rolodex?.nested?.CustomAttributeText?.nested?.Condition && !$root.nested?.squareup?.nested?.client?.nested?.rolodex?.nested?.CustomAttributeEmail && !$root.nested?.squareup?.nested?.client?.nested?.rolodex?.nested?.CustomAttributePhone && !$root.nested?.squareup?.nested?.client?.nested?.rolodex?.nested?.Attachment && !$root.nested?.squareup?.nested?.client?.nested?.rolodex?.nested?.Attachment?.nested?.FileType && !$root.nested?.squareup?.nested?.client?.nested?.rolodex?.nested?.Attachment?.nested?.State && !$root.nested?.squareup?.nested?.client?.nested?.rolodex?.nested?.AppField && !$root.nested?.squareup?.nested?.client?.nested?.rolodex?.nested?.AppField?.nested?.Type && !$root.nested?.squareup?.nested?.client?.nested?.rolodex?.nested?.ContactIncludeDataType && !$root.nested?.squareup?.nested?.client?.nested?.rolodex?.nested?.ContactIncludeResult) {
  $root.addJSON(jsonData);
}

/**
 * Summary of payments made by a contact.
 *
 * SOURCE BuyerSummary @ squareup/client/rolodex/data.proto at 29:1
 */
export const BuyerSummary = $root.lookupType('squareup.client.rolodex.BuyerSummary');
fixType(BuyerSummary);
Builder.createAndAttachToType(BuyerSummary);
/**
 * SOURCE Contact @ squareup/client/rolodex/data.proto at 43:1
 */
export const Contact = $root.lookupType('squareup.client.rolodex.Contact');
fixType(Contact);
Builder.createAndAttachToType(Contact);
/**
 * Older way of specifying application specific data, only used by appointments. New data should go in app_fields instead.
 *
 * SOURCE ApplicationFields @ squareup/client/rolodex/data.proto at 149:1
 */
export const ApplicationFields = $root.lookupType('squareup.client.rolodex.ApplicationFields');
fixType(ApplicationFields);
Builder.createAndAttachToType(ApplicationFields);
/**
 * SOURCE EmailSubscriptions @ squareup/client/rolodex/data.proto at 157:1
 */
export const EmailSubscriptions = $root.lookupType('squareup.client.rolodex.EmailSubscriptions');
fixType(EmailSubscriptions);
Builder.createAndAttachToType(EmailSubscriptions);
/**
 * SOURCE FrequentItem @ squareup/client/rolodex/data.proto at 164:1
 */
export const FrequentItem = $root.lookupType('squareup.client.rolodex.FrequentItem');
fixType(FrequentItem, {
  displayName: {
    required: true
  },
  purchaseCount: {
    required: true
  },
  transactionCount: {
    required: true
  }
});
Builder.createAndAttachToType(FrequentItem);
/**
 * SOURCE Transaction @ squareup/client/rolodex/data.proto at 187:1
 */
export const Transaction = $root.lookupType('squareup.client.rolodex.Transaction');
fixType(Transaction);
Builder.createAndAttachToType(Transaction);
/**
 * SOURCE Itemization @ squareup/client/rolodex/data.proto at 210:1
 */
export const Itemization = $root.lookupType('squareup.client.rolodex.Itemization');
fixType(Itemization);
Builder.createAndAttachToType(Itemization);
/**
 * SOURCE ItemModifier @ squareup/client/rolodex/data.proto at 244:1
 */
export const ItemModifier = $root.lookupType('squareup.client.rolodex.ItemModifier');
fixType(ItemModifier);
Builder.createAndAttachToType(ItemModifier);
/**
 * This Message is same with beemo.item_details.ItemDetail.ItemModifierList.
 *
 * SOURCE ItemModifierList @ squareup/client/rolodex/data.proto at 258:1
 */
export const ItemModifierList = $root.lookupType('squareup.client.rolodex.ItemModifierList');
fixType(ItemModifierList);
Builder.createAndAttachToType(ItemModifierList);
/**
 * SOURCE SelectionType @ squareup/client/rolodex/data.proto at 261:3
 */
ItemModifierList.SelectionType = $root.lookupEnum('squareup.client.rolodex.ItemModifierList.SelectionType').values;
/**
 * The type of group, whether manually created, or a smart group (audience group)
 *
 * SOURCE GroupType @ squareup/client/rolodex/data.proto at 277:1
 */
export const GroupType = $root.lookupEnum('squareup.client.rolodex.GroupType').values;
/**
 * Qualities of customers that Rolodex makes smart groups around
 *
 * SOURCE AudienceType @ squareup/client/rolodex/data.proto at 285:1
 */
export const AudienceType = $root.lookupEnum('squareup.client.rolodex.AudienceType').values;
/**
 * SOURCE Group @ squareup/client/rolodex/data.proto at 308:1
 */
export const Group = $root.lookupType('squareup.client.rolodex.Group');
fixType(Group);
Builder.createAndAttachToType(Group);
/**
 * SOURCE Segment @ squareup/client/rolodex/data.proto at 335:1
 */
export const Segment = $root.lookupType('squareup.client.rolodex.Segment');
fixType(Segment);
Builder.createAndAttachToType(Segment);
/**
 * New Group message related to Grouping & Filtering project. This supports manual groups and
 * smart groups defined as sets of filters.
 *
 * SOURCE GroupV2 @ squareup/client/rolodex/data.proto at 371:1
 */
export const GroupV2 = $root.lookupType('squareup.client.rolodex.GroupV2');
fixType(GroupV2, {
  type: {
    required: true
  },
  groupIdPair: {
    required: true
  },
  merchantToken: {
    required: true
  },
  name: {
    notEmpty: true
  }
});
Builder.createAndAttachToType(GroupV2);
/**
 * SOURCE Type @ squareup/client/rolodex/data.proto at 374:3
 */
GroupV2.Type = $root.lookupEnum('squareup.client.rolodex.GroupV2.Type').values;
/**
 * SOURCE GroupV2Options @ squareup/client/rolodex/data.proto at 418:1
 */
export const GroupV2Options = $root.lookupType('squareup.client.rolodex.GroupV2Options');
fixType(GroupV2Options);
Builder.createAndAttachToType(GroupV2Options);
/**
 * SOURCE GroupV2Counts @ squareup/client/rolodex/data.proto at 425:1
 */
export const GroupV2Counts = $root.lookupType('squareup.client.rolodex.GroupV2Counts');
fixType(GroupV2Counts, {
  numCustomers: {
    required: true
  },
  numEmailable: {
    required: true
  },
  numManual: {
    required: true
  }
});
Builder.createAndAttachToType(GroupV2Counts);
/**
 * This message is not yet used, yet will be on future clients.
 *
 * SOURCE CustomerProfile @ squareup/client/rolodex/data.proto at 437:1
 */
export const CustomerProfile = $root.lookupType('squareup.client.rolodex.CustomerProfile');
fixType(CustomerProfile);
Builder.createAndAttachToType(CustomerProfile);
/**
 * SOURCE InstrumentsOnFile @ squareup/client/rolodex/data.proto at 518:1
 */
export const InstrumentsOnFile = $root.lookupType('squareup.client.rolodex.InstrumentsOnFile');
fixType(InstrumentsOnFile);
Builder.createAndAttachToType(InstrumentsOnFile);
/**
 * SOURCE EventType @ squareup/client/rolodex/data.proto at 523:1
 */
export const EventType = $root.lookupEnum('squareup.client.rolodex.EventType').values;
/**
 * SOURCE Event @ squareup/client/rolodex/data.proto at 569:1
 */
export const Event = $root.lookupType('squareup.client.rolodex.Event');
fixType(Event);
Builder.createAndAttachToType(Event);
/**
 * SOURCE Reminder @ squareup/client/rolodex/data.proto at 584:1
 */
export const Reminder = $root.lookupType('squareup.client.rolodex.Reminder');
fixType(Reminder);
Builder.createAndAttachToType(Reminder);
/**
 * SOURCE Note @ squareup/client/rolodex/data.proto at 591:1
 */
export const Note = $root.lookupType('squareup.client.rolodex.Note');
fixType(Note);
Builder.createAndAttachToType(Note);
/**
 * SOURCE Merchant @ squareup/client/rolodex/data.proto at 612:1
 */
export const Merchant = $root.lookupType('squareup.client.rolodex.Merchant');
fixType(Merchant);
Builder.createAndAttachToType(Merchant);
/**
 * SOURCE MerchantSettings @ squareup/client/rolodex/data.proto at 624:1
 */
export const MerchantSettings = $root.lookupType('squareup.client.rolodex.MerchantSettings');
fixType(MerchantSettings, {
  enableAutomaticContactCreation: {
    required: true
  }
});
Builder.createAndAttachToType(MerchantSettings);
/**
 * Custom attributes in directory
 *
 * SOURCE AttributeSchema @ squareup/client/rolodex/data.proto at 647:1
 */
export const AttributeSchema = $root.lookupType('squareup.client.rolodex.AttributeSchema');
fixType(AttributeSchema);
Builder.createAndAttachToType(AttributeSchema);
/**
 * SOURCE Type @ squareup/client/rolodex/data.proto at 650:3
 */
AttributeSchema.Type = $root.lookupEnum('squareup.client.rolodex.AttributeSchema.Type').values;
/**
 * SOURCE Visibility @ squareup/client/rolodex/data.proto at 662:3
 */
AttributeSchema.Visibility = $root.lookupEnum('squareup.client.rolodex.AttributeSchema.Visibility').values;
/**
 * SOURCE AttributeDefinition @ squareup/client/rolodex/data.proto at 669:3
 */
AttributeSchema.AttributeDefinition = $root.lookupType('squareup.client.rolodex.AttributeSchema.AttributeDefinition');
fixType(AttributeSchema.AttributeDefinition);
Builder.createAndAttachToType(AttributeSchema.AttributeDefinition);
/**
 * SOURCE Attribute @ squareup/client/rolodex/data.proto at 699:3
 */
AttributeSchema.Attribute = $root.lookupType('squareup.client.rolodex.AttributeSchema.Attribute');
fixType(AttributeSchema.Attribute);
Builder.createAndAttachToType(AttributeSchema.Attribute);
/**
 * SOURCE Data @ squareup/client/rolodex/data.proto at 707:5
 */
AttributeSchema.Attribute.Data = $root.lookupType('squareup.client.rolodex.AttributeSchema.Attribute.Data');
fixType(AttributeSchema.Attribute.Data);
Builder.createAndAttachToType(AttributeSchema.Attribute.Data);
/**
 * SOURCE MergeProposal @ squareup/client/rolodex/data.proto at 751:1
 */
export const MergeProposal = $root.lookupType('squareup.client.rolodex.MergeProposal');
fixType(MergeProposal, {
  newContact: {
    required: true
  }
});
Builder.createAndAttachToType(MergeProposal);
/**
 * SOURCE DuplicateContactTokenSet @ squareup/client/rolodex/data.proto at 757:1
 */
export const DuplicateContactTokenSet = $root.lookupType('squareup.client.rolodex.DuplicateContactTokenSet');
fixType(DuplicateContactTokenSet);
Builder.createAndAttachToType(DuplicateContactTokenSet);
/**
 * ContactSet represents a set of contacts in directory
 *
 * SOURCE ContactSet @ squareup/client/rolodex/data.proto at 763:1
 */
export const ContactSet = $root.lookupType('squareup.client.rolodex.ContactSet');
fixType(ContactSet, {
  type: {
    required: true
  }
});
Builder.createAndAttachToType(ContactSet);
/**
 * SOURCE ContactSetType @ squareup/client/rolodex/data.proto at 781:1
 */
export const ContactSetType = $root.lookupEnum('squareup.client.rolodex.ContactSetType').values;
/**
 * ContactBatchActionStatus is used in batch contact action endpoints
 *
 * SOURCE ContactBatchActionStatus @ squareup/client/rolodex/data.proto at 788:1
 */
export const ContactBatchActionStatus = $root.lookupType('squareup.client.rolodex.ContactBatchActionStatus');
fixType(ContactBatchActionStatus);
Builder.createAndAttachToType(ContactBatchActionStatus);
/**
 * Filter uses nested protobuf extensions to mimic inheritance in messages. This is
 * the same approach as rolodex cedas event, and has proven to be a tested and effective
 * cross platoform approach.
 *
 * To use: define a new filter type and the corresponding extension which then will
 * allow you to instatiate a filter by specifying the type and setting the corresponding
 * fields in the extension.
 *
 * SOURCE Filter @ squareup/client/rolodex/data.proto at 804:1
 */
export const Filter = $root.lookupType('squareup.client.rolodex.Filter');
fixType(Filter, {
  type: {
    required: true
  },
  mgGroupTokens: {
    required: true
  },
  xpilydXPayments: {
    required: true
  },
  xpilydYDays: {
    required: true
  },
  xpilydYDaysOptions: {
    required: true
  },
  lpilydYDays: {
    required: true
  },
  npilydYDays: {
    required: true
  },
  npilydYDaysOptions: {
    required: true
  },
  rXPayments: {
    required: true
  },
  rYDays: {
    required: true
  },
  rYDaysOptions: {
    required: true
  },
  catAttributeToken: {
    required: true
  },
  catCondition: {
    required: true
  },
  caeAttributeToken: {
    required: true
  },
  capAttributeToken: {
    required: true
  },
  caenAttributeToken: {
    required: true
  },
  cabAttributeToken: {
    required: true
  },
  fbSentimentType: {
    required: true
  },
  sqSearchQuery: {
    required: true
  },
  hcofHasCardOnFile: {
    required: true
  },
  hlHasLoyalty: {
    required: true
  },
  hvlLocations: {
    required: true
  },
  csCreationSourceTypes: {
    required: true
  },
  iipIsInstantProfile: {
    required: true
  }
});
Builder.createAndAttachToType(Filter);
/**
 * SOURCE Option @ squareup/client/rolodex/data.proto at 809:3
 */
Filter.Option = $root.lookupType('squareup.client.rolodex.Filter.Option');
fixType(Filter.Option, {
  value: {
    notEmpty: true
  },
  label: {
    notEmpty: true
  }
});
Builder.createAndAttachToType(Filter.Option);
/**
 * SOURCE Type @ squareup/client/rolodex/data.proto at 817:3
 */
Filter.Type = $root.lookupEnum('squareup.client.rolodex.Filter.Type').values;
/**
 * cat = CustomAttributeText
 *
 * SOURCE CustomAttributeText @ squareup/client/rolodex/data.proto at 914:1
 */
export const CustomAttributeText = $root.lookupType('squareup.client.rolodex.CustomAttributeText');
fixType(CustomAttributeText);
Builder.createAndAttachToType(CustomAttributeText);
/**
 * SOURCE Condition @ squareup/client/rolodex/data.proto at 915:3
 */
CustomAttributeText.Condition = $root.lookupEnum('squareup.client.rolodex.CustomAttributeText.Condition').values;
/**
 * cae = CustomAttributeEmail
 *
 * SOURCE CustomAttributeEmail @ squareup/client/rolodex/data.proto at 928:1
 */
export const CustomAttributeEmail = $root.lookupType('squareup.client.rolodex.CustomAttributeEmail');
fixType(CustomAttributeEmail);
Builder.createAndAttachToType(CustomAttributeEmail);
/**
 * cap = CustomAttributePhone
 *
 * SOURCE CustomAttributePhone @ squareup/client/rolodex/data.proto at 936:1
 */
export const CustomAttributePhone = $root.lookupType('squareup.client.rolodex.CustomAttributePhone');
fixType(CustomAttributePhone);
Builder.createAndAttachToType(CustomAttributePhone);
/**
 * Attachment - pertains to file attachments associated to customer records
 *
 * SOURCE Attachment @ squareup/client/rolodex/data.proto at 1052:1
 */
export const Attachment = $root.lookupType('squareup.client.rolodex.Attachment');
fixType(Attachment, {
  attachmentToken: {
    notEmpty: true
  },
  contactToken: {
    notEmpty: true
  },
  fileName: {
    notEmpty: true
  },
  state: {
    required: true
  },
  contentType: {
    notEmpty: true
  },
  fileSizeInBytes: {
    required: true
  }
});
Builder.createAndAttachToType(Attachment);
/**
 * [READ ONLY] file_type is for general data type, used to change behavior.
 *
 * SOURCE FileType @ squareup/client/rolodex/data.proto at 1060:3
 */
Attachment.FileType = $root.lookupEnum('squareup.client.rolodex.Attachment.FileType').values;
/**
 * [READ ONLY] Rolodex will only return ACTIVE state Attachments
 *
 * SOURCE State @ squareup/client/rolodex/data.proto at 1068:3
 */
Attachment.State = $root.lookupEnum('squareup.client.rolodex.Attachment.State').values;
/**
 * SOURCE AppField @ squareup/client/rolodex/data.proto at 1096:1
 */
export const AppField = $root.lookupType('squareup.client.rolodex.AppField');
fixType(AppField, {
  appId: {
    required: true
  },
  name: {
    required: true
  }
});
Builder.createAndAttachToType(AppField);
/**
 * SOURCE Type @ squareup/client/rolodex/data.proto at 1097:3
 */
AppField.Type = $root.lookupEnum('squareup.client.rolodex.AppField.Type').values;
/**
 * ContactIncludeDataType represents additional data types to include when fetching Contact data
 *
 * SOURCE ContactIncludeDataType @ squareup/client/rolodex/data.proto at 1125:1
 */
export const ContactIncludeDataType = $root.lookupEnum('squareup.client.rolodex.ContactIncludeDataType').values;
/**
 *  ContactIncludeResult represents a result while fetching additional data for each included ContactIncludeDataType
 *
 * SOURCE ContactIncludeResult @ squareup/client/rolodex/data.proto at 1130:1
 */
export const ContactIncludeResult = $root.lookupType('squareup.client.rolodex.ContactIncludeResult');
fixType(ContactIncludeResult);
Builder.createAndAttachToType(ContactIncludeResult);